// extracted by mini-css-extract-plugin
module.exports = {"menu":"HamburgerMenu_menu__7Jm4Z"};